import React from 'react'
import Footer from '../../components/footer/Footer'
import Navbar from '../../components/navbar/Navbar'

const Ministry = () => {
  return (
    <div>
      <Navbar />
      Ministry
      <Footer />
      </div>
  )
}

export default Ministry